import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCloudsmithComponent } from './simple-icons-cloudsmith.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCloudsmithComponent ],
    exports:      [ SimpleIconsCloudsmithComponent ],
    bootstrap:    []
})
export class SimpleIconsCloudsmithModule {}
